import Vue from 'vue';
// eslint-disable-next-line import/no-duplicates
import EventbusSubscriber from './eventbusSubscriber';
// eslint-disable-next-line import/no-duplicates
import { EventbusCallback } from './eventbusSubscriber';

const EventBus = new Vue();

export default class Eventbus {
  allSubscribers: Array<EventbusSubscriber> = [];
  lastEmitted: Record<string, any> = {};

  static computeEventId(rawId: string): string {
    return rawId.toUpperCase();
  }

  emit(eventId: string, ...args: any): void {
    const computedId = Eventbus.computeEventId(eventId);
    if (args) {
      Vue.$log.info(`⚡ [EVENT] ${computedId}, with arguments:`);
      Vue.$log.info(args);
    } else {
      Vue.$log.info(`⚡ [EVENT] ${computedId}, no arguments given`);
    }
    this.lastEmitted[computedId] = args;
    EventBus.$emit(computedId, ...args);
  }
  on(eventId: string, callback: EventbusCallback, retroActive: boolean = false) {
    const computedId = Eventbus.computeEventId(eventId);
    const matchedSubscribers = this.allSubscribers.filter((sub) => computedId === sub.id && callback === sub.callback);
    if (matchedSubscribers.length > 0) {
      Vue.$log.warning(`⚡ [EVENT] ${computedId}, was subscribed to multiple times`);
    }
    this.allSubscribers.push({ id: computedId, callback });
    if (this.lastEmitted[computedId] && retroActive) {
      Vue.$log.info(`⚡ [EVENT] ${computedId}, with arguments:`);
      Vue.$log.info(this.lastEmitted[computedId]);
      // Cold subscription, emit last data on subscription
      callback(...this.lastEmitted[computedId]);
    }
    EventBus.$on(computedId, callback);
  }
  off(eventId: string, callback: EventbusCallback) {
    const computedId = Eventbus.computeEventId(eventId);
    // Remove unsubscribed
    this.allSubscribers = this.allSubscribers.filter((sub) => !(sub.id === computedId && callback === sub.callback));
    EventBus.$off(computedId, callback);
  }
  offAll(eventId: string) {
    const computedId = Eventbus.computeEventId(eventId);
    const matchedSubs = this.allSubscribers.filter((sub) => sub.id === computedId);
    matchedSubs.forEach((sub) => {
      this.off(sub.id, sub.callback);
    });
  }
}
